import { render, staticRenderFns } from "./AchievementsModal.vue?vue&type=template&id=0ceb5a84&scoped=true&"
import script from "./AchievementsModal.vue?vue&type=script&lang=js&"
export * from "./AchievementsModal.vue?vue&type=script&lang=js&"
import style0 from "./AchievementsModal.vue?vue&type=style&index=0&id=0ceb5a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceb5a84",
  null
  
)

export default component.exports